import { AbstractControl } from '@angular/forms';

export class GpsLatitudeValidation {

  static ValidateDecimal = (region: string) => {
    return (control: AbstractControl) => {
      /*if (region === 'Boston Region') {
        const rex: RegExp = /^-?\d+(\.\d{1,12})?$/;
        if (!rex.test(control.value) && control.value !== '') {
          return { validateDecimal12: true }
        }
        return null;
      }
      else {
        const rex: RegExp = /^-?\d+(\.\d{1,6})?$/;
        if (!rex.test(control.value) && control.value !== '') {
          return { validateDecimal6: true }
        }
        return null;
      }*/
      const rex: RegExp = /^-?\d+(\.\d{6,12})+$/;
        if (!rex.test(control.value) && control.value !== '') {
          return { validateDecimal: true }
        }
        return null;
    }
  }

  static ValidateRange = (region: string) => {
    return (control: AbstractControl) => {
      /*if (region === 'Boston Region') {
        if ((control.value < 40.988192 || control.value > 45.011419) && control.value !== '') {
          return { validateRange: 'Latitude Coordinates Should be in between 40.988192 to 45.011419. Please Verify !' }
        }
        return null;
      }
      if (region === 'Beltway Region') {
        if ((control.value < 36.1 || control.value > 39.8) && control.value !== '') {
          return { validateRange: 'Latitude Coordinates Should be in between 36.1 to 39.8. Please Verify !' }
        }
        return null;
      }
      if (region === 'Freedom Region') {
        if ((control.value < 38.9 || control.value > 41.2) && control.value !== '') {
          return { validateRange: 'Latitude Coordinates Should be in between 38.9 to 41.2. Please Verify !' }
        }
        return null;
      }
      if (region === 'Keystone Region') {
        if ((control.value < 38.1 || control.value > 43.1) && control.value !== '') {
          return { validateRange: 'Latitude Coordinates Should be in between 38.1 to 43.1. Please Verify !' }
        }
        return null;
      }*/
      if ((control.value < 20 || control.value > 50) && control.value !== '') {
        return { validateRange: 'Latitude Coordinates Should be between 20 to 50. Please Verify !' }
      }
    }
  }
}